module.exports = __webpack_public_path__ + "img/services.83cc9358.png";